var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.01V2.5C18 2.22386 17.7761 2 17.5 2H6.5C6.22386 2 6 2.22386 6 2.5V6.03C6 9.02 10 10.75 10 12C10 13.25 6 15.27 6 18.25V21.5C6 21.7761 6.22386 22 6.5 22H17.5C17.7761 22 18 21.7761 18 21.5V18.25C18 15.28 14 13.25 14 12C14 10.75 18 9.02 18 6.01ZM14.75 14.53C15.8 15.57 17.1 16.86 17.1 18.25V19.5H16.2C14.84 19.5 12.88 16.89 12.88 16.89C12.64 16.64 12.4 16.38 11.99 16.38C11.59 16.38 11.34 16.65 11.11 16.89C11.11 16.89 9.23 19.5 7.79 19.5H6.9V18.25C6.9 16.84 8.2 15.56 9.25 14.52C10.17 13.61 10.8 12.89 10.8 12C11.47 12.23 12.47 12.25 13.2 12C13.2 12.9 13.83 13.62 14.75 14.53ZM7.15 7.09C6.99 6.75 6.9 6.4 6.9 6.03V3.25H17.1V6.01C17.1 6.38 17.01 6.73 16.86 7.07C14.39 8.94 9.62 8.94 7.15 7.09Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.41138e92795297b31ebd9535e17bc167.svg";
export { ForwardRef as ReactComponent };